import type { AnyAction, Dispatch } from 'redux';

import * as EmployeeUtilizationChartsAPI from 'ab-api/web/employeeUtilization/findCharts';
import * as EmployeeUtilizationCompanyTableAPI from 'ab-api/web/employeeUtilization/findCompanyTable';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function fetchEmployeeUtilizationForCompanyTable() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<EmployeeUtilizationCompanyTableAPI.W_EmployeeUtilization_FindCompanyTable_VM>(EmployeeUtilizationCompanyTableAPI.URL());
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function fetchEmployeeUtilizationCharts() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<EmployeeUtilizationChartsAPI.W_EmployeeUtilization_FindCharts_VM>(EmployeeUtilizationChartsAPI.URL());
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

